export default __webpack_public_path__ + "static/media/fondogris_Dashport.7d358748.jpg";